import { render } from "./page.vue?vue&type=template&id=7a62ac67"
import script from "./page.vue?vue&type=script&lang=ts"
export * from "./page.vue?vue&type=script&lang=ts"

import "./page.vue?vue&type=style&index=0&id=7a62ac67&lang=less"
script.render = render

export default script